import { writable } from "svelte/store"

export const cards = writable([])